import { FunctionComponent } from 'react';
import { Head } from 'nordic/head';
import { Page } from 'nordic/page';

import type { PlatformId, SiteId } from 'frontend-platform_detection';
import { AndesProvider } from '@andes/context';
import type { Locale } from 'nordic/i18n';
import PlatfromWrapper from '../../components/platform-context';
import type { ErrorWordings } from '../../wordings';

import StyleAsset from '../../components/style-asset';
import { GATrack, MelidataTrack } from '../../../services/Track';
import Error from './components/Error';


export type ErrorViewProps = {
  wordings: ErrorWordings
  locale: Locale
  isWebview: boolean
  isMobile: boolean
  platformId: PlatformId
  siteId: SiteId
  homeUrl: string,
  type: string
  tracks: {
    melidata: MelidataTrack
    analytics: GATrack
  }
}

const ErrorView: FunctionComponent<ErrorViewProps> = (props: ErrorViewProps) => {
  const { wordings, locale, isWebview, isMobile, platformId, siteId, homeUrl, type, tracks } = props;
  const { melidata, analytics } = tracks;

  const stateProps = { wordings, locale, isWebview, isMobile, platformId, siteId, homeUrl, type, tracks };

  return (
    <AndesProvider locale={locale}>
      <Page
        name="error"
        className="error"
        melidata={melidata}
        analytics={analytics}
        state={stateProps}
        styles={false}
      >
        <StyleAsset viewName="error" platformId={platformId} />
        <Head>
          <title>{wordings.title}</title>
        </Head>

        <PlatfromWrapper platform={platformId}>
          <Error
            wordings={wordings}
            isWebview={isWebview}
            isMobile={isMobile}
            homeUrl={homeUrl}
            type={type}
          />
        </PlatfromWrapper>
      </Page>
    </AndesProvider>
  );
};

export default ErrorView;
